<template>
  <div class="backgroud-white cs-courseSchedule-editor addpayment-editor">
    <div class="text-center">
      <br><span style="font-size:12px;color:#b5b5b5">若金额不足，请于速成前台充值</span>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <div class="paymenttype-list">
        <div
          :class="{'paymenttype-list-item-wrapper': true}"
          v-for="(item, itemIndex) in paymentTypes"
          :key="itemIndex"
          @click="onClickPayment(item)"
        >
          <div :class="{'active' : paymentTypeId == item.type, 'paymenttype-list-item': true}">
            <img
              v-if="paymentTypeId == item.type"
              :src="item.srcActive"
              class="radio-img"
            >
            <img
              v-else
              :src="item.src"
              class="radio-img"
            >
            <span>{{item.description}}</span>
            <span v-if="item.type == 1">{{dataIn.memberInfo.BonusPoint}} ({{bonusPointAmount|toCurrency}})</span>
            <span v-else>{{dataIn.memberInfo.Balance + dataIn.memberInfo.NewBalance + dataIn.memberInfo.GiftBalance | toCurrency}}</span>
            <img
              v-if="paymentTypeId == item.type"
              :src="srcIconSelected"
              class="iconSelected"
            >
          </div>

          <el-form
            v-if="item.type == 2"
            ref="balanceCostForm"
            :model="dataModel"
            :rules="bcRules"
            label-width="90px"
            label-position="left"
          >

            <el-form-item
              label="使用余额："
              prop="balanceCost"
            >{{dataModel.balanceCost}}
              <!-- <el-input
                placeholder="请输入余额数值"
                v-model="dataModel.balanceCost"
                class="input-width"
                size="small"
              >
              </el-input> -->
            </el-form-item>
          </el-form>
          <el-form
            v-else
            ref="bonusPointCostForm"
            :model="dataModel"
            :rules="bpcRules"
            label-width="90px"
            label-position="left"
          >
            <el-form-item
              label="使用积分："
              prop="bonusPointCost"
            >{{dataModel.bonusPointCost}}
              <!-- <el-input
                placeholder="请输入积分数值"
                :disabled="!dataIn.memberInfo.IsMember"
                v-model="dataModel.bonusPointCost"
                class="input-width"
                size="small"
              >
              </el-input> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
   
      <div class="member-info">
        <el-row>
          <el-col :span="4">
            &nbsp;
          </el-col>
          <el-col :span="4">
            <span>价格：</span>
          </el-col>
          <el-col :span="8">
            <span>{{dataIn.price | toCurrency}} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            &nbsp;
          </el-col>
          <el-col :span="4">
            <span>已付：</span>
          </el-col>
          <el-col :span="8">
            <span>{{(convertToDecimal(dataModel.balanceCost) + bonusPointPrice) | toCurrency}}</span>
            <span class="cs-payment-use">(使用积分：{{ dataModel.bonusPointCost }}</span>
            <span class="cs-payment-use">使用余额：{{convertToDecimal(dataModel.balanceCost) | toCurrency}})</span>
          </el-col>
        </el-row>
        <el-row class="cs-redLabel">
          <el-col :span="4">
            &nbsp;
          </el-col>
          <el-col :span="4">
            <span>应付：</span>
          </el-col>
          <el-col :span="8">
            <span>{{payLeft | toCurrency}}</span>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row style="font-size:12px;color:#b5b5b5">
          <el-col :span="4">
            &nbsp;
          </el-col>
          <el-col :span="20">
            非会员不能使用积分
            <!-- <br>
            输入的积分和余额合计值需等于价格，即应付为0时完成支付。 -->
          </el-col>
        </el-row>
      </div> 
    </div>

    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col class="footer-center">
          <el-button
            type="primary"
            @click="savePayment"
          >确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.paymenttype-list {
  text-align: center;
  .paymenttype-list-item-wrapper {
    display: inline-block;
    width: 170px;
    &:first-of-type {
      margin-right: 2rem;
    }

    .el-input {
    }
  }

  .paymenttype-list-item {
    width: 170px;
    //height: 120px;
    //border: 1pt solid #e0e0e0;
    background-color: #fafafa;
    //color: #e6e7e8;
    border-radius: 3px;
    position: relative;
    //border-color: #357ec7;
    border: 1pt solid #357ec7;
    color: #006ab4;
    cursor: pointer;
    padding-top: 20px;
    padding-bottom: 20px;

    &.active {
      border: 1pt solid #006ab4;
      color: #006ab4;
    }

    .radio-img {
      height: 48px;
      width: 48px;
    }

    span {
      margin-top: 10px;
      display: block;

      &:last-of-type {
        margin-top: 5px;
      }
    }

    .iconSelected {
      position: absolute;
      height: 20px;
      top: -10px;
      right: -10px;
      z-index: 99;
    }

    &.active {
      border-color: #357ec7;
    }
  }
}
.member-info {
  //margin-top: 2rem;
}
.cs-payment-use{
  display: inline-block;
  margin-left: 5px;
}
</style>

<script>
import { guid, toDecimal  } from "../../config/mUtils";

export default {
  props: {
    dataIn: {
      price: Number,
      memberInfo: Object,
      priceSettings: {
        bonusPointToMoney_Money: Number,
        bonusPointToMoney_BonusPoint: Number
      }
    }
  },
  compontents: {},
  data() {
    let self = this;

    let validateBalanceCost = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!!value && !isValid) {
        message = "请输入正确的余额数值";
      }

      if (!message && value > self.dataIn.memberInfo.Balance + self.dataIn.memberInfo.NewBalance + self.dataIn.memberInfo.GiftBalance) {
        message = "余额数值不能大于可用余额";
      }

      if (!message && value > self.price) {
        message = "余额数值不能大于应付价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateBonusPointCost = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!!value && !isValid) {
        message = "请输入正确的积分数值";
      }

      if (!message && value > self.dataIn.memberInfo.BonusPoint) {
        message = "积分数值不能大于可用积分";
      }

      if (!message && self.bonusPointPrice > self.price) {
        message = `积分抵扣(${self.bonusPointPrice})不能大于应付价格`;
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      paymentTypeId: 2,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      paymentTypes: [
        {
          type: 1,
          description: "会员积分",
          srcActive: require("../../assets/icon-credit.png"),
          src: require("../../assets/icon-credit-grey.png")
        },
        {
          type: 2,
          description: "账户余额",
          srcActive: require("../../assets/icon-balance.png"),
          src: require("../../assets/icon-balance-grey.png")
        }
      ],
      srcIconSelected: require("../../assets/icon-selected.png"),
      dataModel: {
        balanceCost: 0,
        bonusPointCost: 0
      },
      bcRules: {
        balanceCost: [
          {
            validator: validateBalanceCost,
            trigger: "blur"
          }
        ]
      },
      bpcRules: {
        bonusPointCost: [
          {
            validator: validateBonusPointCost,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    bonusPointAmount: function() {
      if (
        !!this.dataIn &&
        !!this.dataIn.priceSettings &&
        !!this.dataIn.memberInfo &&
        this.dataIn.priceSettings.bonusPointToMoney_BonusPoint > 0
      ) {
        let value =
          toDecimal((toDecimal(this.dataIn.memberInfo.BonusPoint) *
            this.dataIn.priceSettings.bonusPointToMoney_Money) /
          this.dataIn.priceSettings.bonusPointToMoney_BonusPoint);
        return value;
      }
      return 0;
    },
    bonusPointPrice: function() {
      if (
        !!this.dataIn &&
        !!this.dataIn.priceSettings &&
        this.dataIn.priceSettings.bonusPointToMoney_BonusPoint > 0
      ) {
        let value =
          toDecimal((parseInt(this.dataModel.bonusPointCost) *
            this.dataIn.priceSettings.bonusPointToMoney_Money) /
          this.dataIn.priceSettings.bonusPointToMoney_BonusPoint);
        return value;
      }
      return 0;
    },
    payLeft: function() {
      if (
        !!this.dataIn &&
        !!this.dataIn.priceSettings &&
        this.dataIn.priceSettings.bonusPointToMoney_BonusPoint > 0 &&
        this.dataIn.price > 0
      ) {
        let value =
          this.dataIn.price - this.bonusPointPrice - toDecimal(this.dataModel.balanceCost);
        return value;
      }
      return 0;
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    convertToDecimal(x){
      return toDecimal(x);
    },
    init() {
      this.dataModel.balanceCost = 0;
      this.dataModel.bonusPointCost = 0;
      this.paymentTypeId = 2;
      this.setPayment();
    },
    onClickPayment(item) {
      if (!this.dataIn.memberInfo.IsMember && item.type == 1){
        this.$message("非会员不能使用积分");
        return;
      }
      
      this.paymentTypeId = item.type;
      this.setPayment();
    },
    setPayment(){
      if ( !this.dataIn.memberInfo.IsMember && this.paymentTypeId == 1 ){
        return;
      }
      let balanceCost = 0;
      let bonusPointCost = 0;
      if (this.paymentTypeId == 1){
        if (this.dataIn.price > this.bonusPointAmount ){
          bonusPointCost = this.dataIn.memberInfo.BonusPoint;
          balanceCost = this.dataIn.price - this.bonusPointAmount;
          if (balanceCost > this.totalBalance){
            balanceCost = this.totalBalance;
          }
        }else{
          bonusPointCost = this.getBonusPointCost(this.dataIn.price);
        }
      }else{
        if (this.dataIn.price > this.totalBalance ){
          balanceCost = this.totalBalance;
          if ( this.dataIn.memberInfo.IsMember){
            let bonusPointPrice = this.dataIn.price - this.totalBalance;
            bonusPointCost = this.getBonusPointCost(bonusPointPrice);
            if (bonusPointCost > this.dataIn.memberInfo.BonusPoint){
              bonusPointCost = this.dataIn.memberInfo.BonusPoint;
            }
          }
        }else{
          balanceCost = this.dataIn.price;
        }
      }
      this.dataModel.balanceCost = balanceCost;
      this.dataModel.bonusPointCost = bonusPointCost;
    },
    getBonusPointPrice(bonusPointCost){
      if (
        !!this.dataIn &&
        !!this.dataIn.priceSettings &&
        this.dataIn.priceSettings.bonusPointToMoney_BonusPoint > 0
      ) {
        let value =
          toDecimal((parseInt(bonusPointCost) *
            this.dataIn.priceSettings.bonusPointToMoney_Money) /
          this.dataIn.priceSettings.bonusPointToMoney_BonusPoint);
        return value;
      }
    },
    getBonusPointCost(bonusPointPrice){
      if (
        !!this.dataIn &&
        !!this.dataIn.priceSettings &&
        this.dataIn.priceSettings.bonusPointToMoney_BonusPoint > 0
      ) {
        let value =
          toDecimal((bonusPointPrice *
            this.dataIn.priceSettings.bonusPointToMoney_BonusPoint) /
          this.dataIn.priceSettings.bonusPointToMoney_Money);
        return value;
      }
    },
    savePayment() {
      
      let isValid = true;
      let refBPC = this.$refs["bonusPointCostForm"][0];
      let refBC = this.$refs["balanceCostForm"][0];
      if (!!refBPC) {

        refBPC.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (!!refBC && isValid) {
        refBC.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (!isValid){
        return;
      }
      let balanceCost = toDecimal(this.dataModel.balanceCost);

      if ((balanceCost + this.bonusPointPrice) < this.dataIn.price ){
        this.$message.error("金额不足，请于速成前台充值");
        //this.$message.error("请完成付款");
        return;
      }

      if ((balanceCost + this.bonusPointPrice) > this.dataIn.price ){
        this.$message.error("付款金额不能大于应付价格");
        return;
      }

      let result = [];
      if (parseInt(this.dataModel.bonusPointCost) > 0){
        result.push(this.getPaymentItem(1, this.bonusPointPrice));
      }
      if (balanceCost > 0){
        result.push(this.getPaymentItem(2, balanceCost));
      }

      this.$emit("save", result);
    },
    getPaymentItem(paymentType, amount) {
      let title = "";
      switch (paymentType) {
        case 1: {
          title = "积分支付";
          break;
        }
        case 2: {
          title = "余额支付";
          break;
        }
      }
      let payment = {
        Id: guid(),
        AccountId: 0,
        PaymentTypeId: paymentType,
        Amount: amount,
        Tax: 0,
        ServiceCharge: 0,
        Title: title,
        Enable: true
      };
      return payment;
    },
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappPayEditor.vue